module.exports = __webpack_public_path__ + "static/img/funny_25.b057140f.jpg";